<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.00088 8C9.21002 8 11.0009 6.20914 11.0009 4C11.0009 1.79086 9.21002 0 7.00088 0C4.79174 0 3.00088 1.79086 3.00088 4C3.00088 6.20914 4.79174 8 7.00088 8ZM5.4001 9.60013C2.74913 9.60013 0.600098 11.7492 0.600098 14.4001C0.600098 15.2838 1.31644 16.0001 2.2001 16.0001H11.8001C12.6838 16.0001 13.4001 15.2838 13.4001 14.4001C13.4001 11.7492 11.2511 9.60013 8.60009 9.60013H5.4001Z"
    fill="currentColor"
  />
</template>
